import * as React from "react";
import {TransportOrder} from "../../../../../generated";
import AceEditor from "react-ace";
import {Button, Icon, Label} from "semantic-ui-react";
import {TransportOrderSaveModal} from "../modals/TransportOrderSaveModal";
import {TransportOrderSourceAndTargetViewModal} from "../modals/TransportOrderSourceAndTargetViewModal";
import {IfBox} from "../../../../style/if";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";

export interface TransportOrderEditViewProps {
    reload: (reload: boolean) => void
    transportOrder: TransportOrder
}

export function TransportOrderEditView(props: TransportOrderEditViewProps) {

    const [transportOrderStr, setTransportOrderStr] = React.useState<string>("");
    const [transportOrder, setTransportOrder] = React.useState<TransportOrder | null>(null);
    const [validJson, setValidJson] = React.useState(true);
    const [showSaveModal, setShowSaveModal] = React.useState(false);
    const [showSourceAndTargetViewModal, setShowSourceAndTargetViewModal] = React.useState(false);

    //Immediate Format
    const [loadingIfMode, setLoadingIfMode] = React.useState(false);
    const [IfMode, setIfMode] = React.useState(false);
    const [IfOrder, setIfOrder] = React.useState("");

    React.useEffect(() => {
        updateTransportOrder(props.transportOrder);
        setIfMode(false);
        setIfOrder("");
        // eslint-disable-next-line
    }, [props.transportOrder]);

    function handleTransportOrderChange(newEvent: string) {
        setTransportOrderStr(newEvent);
        try {
            const to = JSON.parse(newEvent);
            setValidJson(true);
            setTransportOrder(to);
        } catch (e) {
            setValidJson(false);
        }
    }

    function updateTransportOrder(to: TransportOrder) {
        if (to) {
            setTransportOrderStr(JSON.stringify(to, null, 4));
        } else {
            setTransportOrderStr("");
        }
    }

    function getTransportOrderId() {
        try {
            return JSON.parse(transportOrderStr)?._id;
        } catch (e) {
            return "";
        }
    }

    async function loadIfFormat() {
        setLoadingIfMode(true);
        if(IfOrder == null || IfOrder === "") {
            let auth = backend.withTokenAuthHeader(authentication.token)
            let response = await backend.internalApi.viewTransportOrderAsImmediateFormat(getTransportOrderId(), auth)
            setIfOrder(JSON.stringify(response.entries, null, 4));
        }
        setIfMode(true);
        setLoadingIfMode(false);
    }

    return (
        <>
            {!validJson ? (
                <Label size={'huge'} color='red' pointing="below">
                    INVALID JSON
                </Label>
            ) : null}
            {IfMode ? <AceEditor
                theme="monokai"
                mode="json"
                value={IfOrder}
                style={{flex: 1}}
                width="100%"
                readOnly={true}
            /> : <AceEditor
                theme="monokai"
                mode="json"
                value={transportOrderStr}
                onChange={handleTransportOrderChange}
                style={{flex: 1}}
                width="100%"
                readOnly={false}
            />}
            <div>
                <Button
                    icon
                    disabled={!validJson}
                    onClick={() => setShowSaveModal(true)}
                >
                    <Icon name='save'/>Save
                </Button>
                <Button
                    icon
                    disabled={!validJson}
                    onClick={() => setShowSourceAndTargetViewModal(true)}
                >
                    source- & target-view
                </Button>
                <Button
                    primary={IfMode}
                    loading={loadingIfMode}
                    disabled={!validJson}
                    onClick={() => {
                        if(!IfMode) {
                            loadIfFormat().then()
                        } else {
                            setIfMode(false);
                        }
                    }}
                >
                    {IfMode ? "Exit Immediate Format" : "Immediate Format"}
                </Button>
            </div>
            <IfBox shouldShow={showSourceAndTargetViewModal}>
                <TransportOrderSourceAndTargetViewModal
                    isOpen={showSourceAndTargetViewModal}
                    onClose={() => setShowSourceAndTargetViewModal(false)}
                    transportOrderId={getTransportOrderId()}
                />
            </IfBox>
            <TransportOrderSaveModal
                isOpen={showSaveModal}
                onClose={() => setShowSaveModal(false)}
                transportOrder={transportOrder}
                oldTransportOrder={props.transportOrder}
            />
        </>
    );
}